const parseJSON = (data, fallback, onError) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    onError(e, data);
    return fallback;
  }
};
export default parseJSON;